import { render } from "./LogoLink.vue?vue&type=template&id=507feb06&scoped=true"
import script from "./LogoLink.vue?vue&type=script&lang=js"
export * from "./LogoLink.vue?vue&type=script&lang=js"

import "./LogoLink.vue?vue&type=style&index=0&id=507feb06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507feb06"]])

export default __exports__